import { axiosClient } from '../axiosClient';

export const updateMyPassword = (new_password: string) => {
  return axiosClient.put('/me/change-password', { new_password });
};
